import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionStatus } from "../../../common/constants/action-status";
import { StoreState } from "../../../store/store.interface";
import { checkIsEmailUnique } from "../api/check-is-user-unique";
import { handleApiError, ApiError } from "../../../common/utils/api-utils";

export const validateUniqueEmail = createAsyncThunk(
    'userProfile/validateUniqueEmail',
    async ({ email }: { email: string }, thunkAPI) => {
      try {
        return await checkIsEmailUnique(email);
      } catch (error) {
        console.error(error);
        if (error instanceof ApiError) {
          handleApiError(error);
        }
        return thunkAPI.rejectWithValue(error);
      }
    },
    {
      condition: (_arg, { getState }) => {
        const state = getState() as StoreState;
        return state.userProfileState.updateProfile.uniqueEmailState.status !== ActionStatus.loading;
      },
    }
  );
  